// src/components/common/LoadingScreen.tsx
import { Box, CircularProgress, Typography } from "@mui/material";

export default function LoadingScreen({ label = "Loading..." }: { label?: string }) {
  return (
    <Box sx={{ minHeight: "50vh", display: "grid", placeItems: "center" }}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Box>
    </Box>
  );
}
